import { render } from "./SignUpOTPVerification.vue?vue&type=template&id=0c66855f&scoped=true"
import script from "./SignUpOTPVerification.vue?vue&type=script&lang=js"
export * from "./SignUpOTPVerification.vue?vue&type=script&lang=js"

import "./SignUpOTPVerification.vue?vue&type=style&index=0&id=0c66855f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c66855f"]])

export default __exports__